module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"メールを送信しました":"メールを送信しました"},"en":{"メールを送信しました":"Email has been sent."}}')
  delete Component.options._Ctor
}
